import { render, staticRenderFns } from "./List.vue?vue&type=template&id=3849c400&scoped=true"
import script from "./List.vue?vue&type=script&lang=js"
export * from "./List.vue?vue&type=script&lang=js"
import style0 from "./List.vue?vue&type=style&index=0&id=3849c400&prod&lang=scss&scoped=true"
import style1 from "./List.vue?vue&type=style&index=1&id=3849c400&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3849c400",
  null
  
)

export default component.exports